<template>
  <section class="dashboard-card supportive-evidence-card">
    <h3>Supportive Evidence</h3>

    <p class="subtitle">
      Supportive evidence for metric verification
    </p>

    <div class="evidence-list">
      <div
        v-for="item in evidenceItems"
        :key="item"
        class="evidence-item"
      >
        {{ item }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SupportiveEvidenceSection",

  data() {
    return {
      evidenceItems: [
        "Further traffic lights",
        "Supplementary KPIs",
        "Finding presentation",
        "Critical sensor health"
      ]
    };
  }
};
</script>

<style scoped>
.dashboard-card {
  background: var(--color-primary);
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.supportive-evidence-card {
  min-height: 100%;
}

.dashboard-card h3 {
  margin: 0 0 8px;
  color: #0f172a;
  font-size: 18px;
}

.subtitle {
  margin: 0 0 16px;
  color: #64748b;
  font-size: 14px;
}

.evidence-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.evidence-item {
  border-radius: 12px;
  padding: 14px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
}
</style>
